import React from 'react';
import Section from './section';
import SimpleReportTable, { SimpleReportTableColumn } from './simpleReportTable';

interface VehicleRiskData {
    data: any[];
}

// 本周车辆风险明细模块
const WeeklyVehicleRiskDetails = (props: VehicleRiskData) => {
    const { data = [] } = props;
    const columns: SimpleReportTableColumn[] = [
        { title: '车辆等级', dataIndex: '安全级别', key: 'vehicleLevel' },
        { title: '车辆', dataIndex: 'plate_number', key: 'vehicle' },
        { title: '车辆类型', dataIndex: 'car_type', key: 'vehicleType' },
        { title: '车队', dataIndex: 'fleet_name', key: 'fleet' },
        { title: '安全指数评分', dataIndex: 'safe_score', key: 'safetyScore' },
        { title: '设备预警评分', dataIndex: 'device_alarm_score', key: 'deviceWarningScore' },
        { title: '精神状态评分', dataIndex: 'mental_state_score', key: 'mentalStateScore' },
        { title: '线路安全评分', dataIndex: 'line_safe_score', key: 'routeSafetyScore' },
        { title: '驾驶习惯评分', dataIndex: 'driver_habit_score', key: 'drivingHabitScore' },
        { title: '工作强度评分', dataIndex: 'work_intensity_score', key: 'workIntensityScore' },
        { title: '风险点评', dataIndex: 'comments', key: 'riskComment' },
    ];
    return (
        <Section title="三、本周车辆风险明细">
            <SimpleReportTable
                columns={columns}
                dataSource={data}
                rowKey="plate_number"
                scrollX
                emptyText="暂无车辆风险明细"
            />
        </Section>
    );
};

export default WeeklyVehicleRiskDetails;
